module.exports = __webpack_public_path__ + "static/media/C3.dad43369.jpg";